import type { MessageProps } from './types';

import { IconButton, PencilIcon, TrashIcon, classNames } from '@movingimage-evp/mi-ui-component-library';
import { formatDistance } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { LinkifiedMessage } from '../../../components/chat/linkified-message';
import { useChat } from '../../../components/chat/use-sendbird-chat';

import styles from './message.module.css';

export function ModeratorMessage({
  message,
  testId = 'chat-message',
  readOnly,
  locale,
  onEdit,
  onDelete,
}: MessageProps) {
  const { t } = useTranslation();
  const { user } = useChat();

  const fullTestId = `${testId}-${message.messageId}`;
  const sentByCurrentUser = message.sender.userId === user?.userId;

  return (
    <div
      data-testid={fullTestId}
      className={classNames(styles.wrapper, styles.sentByModerator, readOnly && styles.readOnly)}
    >
      <header className={styles.header}>
        <div className={styles.sender}>
          <div className={styles.info}>
            <span data-testid={`${fullTestId}-sender`}>{t('common.moderator')}</span>

            <span data-testid={`${fullTestId}-date`} className={styles.date}>
              {formatDistance(new Date(message.createdAt || 0), new Date(), { addSuffix: true, locale })}
            </span>
          </div>
        </div>
      </header>

      <div data-testid={`${fullTestId}-text`} className={styles.text}>
        <LinkifiedMessage>{message.message}</LinkifiedMessage>
      </div>

      {sentByCurrentUser && !readOnly && (
        <div className={styles.editButtons}>
          <IconButton
            data-testid={`${fullTestId}-edit-button`}
            aria-label={t('components.chatModerationDashboard.message.edit')}
            rounded
            onClick={() => onEdit?.(message)}
          >
            <PencilIcon />
          </IconButton>

          <IconButton
            data-testid={`${fullTestId}-delete-button`}
            aria-label={t('components.chatModerationDashboard.message.delete')}
            rounded
            onClick={() => onDelete?.(message)}
          >
            <TrashIcon />
          </IconButton>
        </div>
      )}
    </div>
  );
}
